import styled from 'styled-components';
import Colors from 'enums/Colors';
import { MobileMaxWidth } from 'constants/Dimensions';

export const IaraSectionContainer = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${Colors.White};
    gap: 80px;
    padding: 0 40px;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        gap: 0;
        width: 100%;
        padding: 48px 14px 40px;
        box-sizing: border-box;
    }
`;

export const IaraImage = styled.img`
    width: 320px;
    height: auto;
    flex-shrink: 0;
    align-self: flex-end;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        display: block;
        width: 240px;
        height: auto;
        align-self: auto;
        margin: 0 0 24px;
    }
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 390px;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        max-width: 100%;
        flex-shrink: 0;
        box-sizing: border-box;
    }
`;

export const Title = styled.h1`
    width: 450px;
    margin: 0 0 28px;
    font-family: 'Barlow', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 100%;
    color: ${Colors.Blue};

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        width: 100%;
        margin: 0 0 24px;
        font-size: 24px;
        line-height: 100%;
    }
`;

export const Description = styled.p`
    margin: 0 0 28px;
    font-family: 'Barlow', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${Colors.Blue};

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        width: 280px;
        margin: 0 0 24px;
        font-size: 16px;
        line-height: 150%;
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 127px;
    height: 48px;
    padding: 0;
    border: none;
    border-radius: 4px;
    background-color: ${Colors.Blue};
    color: ${Colors.White};

    font-family: 'Barlow', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;

    cursor: pointer;

    &:hover {
        background-color: ${Colors.DarkBlue3};
    }

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        width: 127px;
        height: 48px;
    }
`;

export const QRCodeImage = styled.img`
    width: 140px;
    height: 140px;
    object-fit: contain;
    flex-shrink: 0;
    margin-top: 110px;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        display: block;
        width: 140px;
        height: 140px;
        align-self: flex-start;
        margin: 28px 0 0;
    }
`;
